import { ChangeEvent, FC, useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import Block from "../../components/Block.component";
import { Button, Col, DropdownItem, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Add, Close, Dashboard, Delete, Logout, Search } from "@mui/icons-material";
import Swal from "sweetalert2";
import colors from "../../config/Colors.config";
import Cookies from 'universal-cookie';
import DeviceConfig from "../../config/Device.config";
import Tiempo from "../../tools/Tiempo.tool";
import UsuarioModel from "../../models/Usuario.model";
import Fecha from "../../tools/Fecha.tool";
import ComponentsCSS from "../../assets/css/Components.css";
import { IconButton } from "@mui/material";
import Table, { TableColumn } from 'react-data-table-component';
import Reclamo from "../../interfaces/Reclamo.interface";
import ReclamoService from "../../services/Reclamo.service";
import Response from "../../interfaces/Response.interface";
import iconGoogleDocs from "../../assets/icons/google-docs.png";
import MonedaTool from "../../tools/Moneda.tools";
import ReclamoModel from "../../models/Reclamo.model";
import Numero from "../../tools/Number.tool";
import { MedioAtencion, Estado, Localidad } from "../../interfaces/SEPOMEX.interface";
import SEPOMEXService from "../../services/SEPOMEX.service";
import Producto from "../../interfaces/Producto.interface";
import ConsultaService from "../../services/Consulta.service";
import Causa from "../../interfaces/Causa.interface";
import Ciudad from "../../interfaces/Ciudad.interface";

const cookies = new Cookies();

interface Trimestre { IdTrimestre: number, trimestre: string }
interface NA { index: number, label: string }

const ReclamacionesIndex: FC = () => {
    const [labelUltimaActualizacion, setLabelUltimaActualizacion] = useState<string>(Tiempo.getCurrentTimeFormat12Hour());
    const [device, setDevice] = useState(DeviceConfig.getData());
    const [fechaInicial, setFechaInicial] = useState<string>(Fecha.getDateToDay());
    const [fechaFinal, setFechaFinal] = useState<string>(Fecha.getDateToDay());
    const [mediosAtencionLista, setMediosAtencion] = useState<MedioAtencion[]>([]);
    const [productosLita, setProductosLista] = useState<Producto[]>([]);
    const [causasLista, setCausaLista] = useState<Causa[]>([]);
    const [estadosLista, setEstadosLista] = useState<Estado[]>([]);
    const [ciudadesLista, setCiudadesLista] = useState<Ciudad[]>([]);
    const [localidadLista, setLocalidadLista] = useState<Localidad[]>([]);

    const [reclamosLista, setReclamosLista] = useState<Reclamo[]>([]);
    const [reclamo, setReclamo] = useState<Reclamo>(ReclamoModel.getEstructura());
    const [isOpenModalReclamo, setIsOpenModalReclamo] = useState<boolean>(false);
    const [arrayErrors, setArrayErrors] = useState<string[]>([]);
    const [isOpenModalErrors, setIsOpenModalErrors] = useState<boolean>(false);

    const arrayStatus: string[] = ["", "Pendiente", "Concluido"];
    const lista: NA[] = [
        { index: 1, label: "UNE" },
        { index: 2, label: "Sucursal" },
        { index: 3, label: "Centro de atención telefónica" },
        { index: 4, label: "Oficinas de atención" },
    ]
    const listaTrimestre: Trimestre[] = [
        {
            IdTrimestre: 1,
            trimestre: "1er Trimestre (1 de enero al 31 de marzo)",
        },
        {
            IdTrimestre: 2,
            trimestre: "2do Trimestre (1 de abril al 30 de junio)",
        },
        {
            IdTrimestre: 3,
            trimestre: "3er Trimestre (1 de julio al 30 de septiembre)",
        },
        {
            IdTrimestre: 4,
            trimestre: "4to Trimestre (1 de octubre al 31 de diciembre)",
        },
    ]
    const columnsReclamos: TableColumn<Reclamo>[] = [
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > FOLIO </Label>,
            cell: (reclamo: Reclamo) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{reclamo.folioAtencion}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > Estatus </Label>,
            cell: (reclamo: Reclamo) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{arrayStatus[reclamo.estadoConPend]}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > FECHA RECEPCIÓN </Label>,
            cell: (reclamo: Reclamo) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{Fecha.formatoSimple(reclamo.fechaReclamacion)}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > FECHA ATENCIÓN </Label>,
            cell: (reclamo: Reclamo) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{reclamo.estadoConPend === 1 ? <i>Pendiente</i> : Fecha.formatoSimple(reclamo.fechaAbonoImporte)}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > MONETARIO </Label>,
            cell: (reclamo: Reclamo) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{reclamo.monetario}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > MONTO ABONADO </Label>,
            cell: (reclamo: Reclamo) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{reclamo.monetario === "SI" ? MonedaTool.convertir(reclamo.importeAbonado) : <i>No aplica</i>}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} >  </Label>,
            cell: (reclamo: Reclamo) =>
                <>
                    {/* --- */}
                    <IconButton
                        onClick={() => eliminarReclamo(reclamo)}
                    >
                        <Delete style={{ color: colors.rojo }} />
                    </IconButton>
                    <IconButton
                        onClick={() => {
                            listarCausasProductosLista(reclamo.productoServicio);
                            listarCiudades(reclamo.entidadFederativa);
                            listarLocalidad(reclamo.entidadFederativa, reclamo.municipioAlcaldia);
                            setReclamo(reclamo);
                            setIsOpenModalReclamo(true);
                        }}
                    >
                        <img style={{ width: 23 }} src={iconGoogleDocs} alt="/*-" />
                    </IconButton>
                </>,
        },
    ]

    useEffect(() => {
        cargarDatos();
        listarEstadosLista();
        getMediosAtencionLista();
        listarProductosLista();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getMediosAtencionLista = async (): Promise<void> => {
        const response: Response = await SEPOMEXService.getMediosAtencionLista();
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const mediosAtencionLista: MedioAtencion[] = value;
            setMediosAtencion(mediosAtencionLista);
        }
    }

    const listarProductosLista = async (): Promise<void> => {
        const response: Response = await ConsultaService.listarProductos();
        if (response.error === true) {
            toast.error("Error");
        } else {
            const productosLista: Producto[] = response.data.value ?? [];
            setProductosLista(productosLista);
        }
    };

    const listarCausasProductosLista = async (IdProducto: string): Promise<void> => {
        const response: Response = await ConsultaService.causaListarProductos(IdProducto);
        if (response.error === true) {
            toast.error("Error");
        } else {
            const causasLista: Causa[] = response.data.value ?? [];
            setCausaLista(causasLista);
        }
    };

    const listarEstadosLista = async (): Promise<void> => {
        const response: Response = await SEPOMEXService.getEstadosLista();
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const estadosLista: Estado[] = value;
            setEstadosLista(estadosLista);
        }
    }

    const listarCiudades = async (IdEstado: number): Promise<void> => {
        const response: Response = await SEPOMEXService.getCiudadesLista(IdEstado);
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const ciudadesLista: Ciudad[] = value;
            setCiudadesLista(ciudadesLista);
        }
    }

    const listarLocalidad = async (IdEstado: number, IdCiudad: number): Promise<void> => {
        const response: Response = await SEPOMEXService.getLocalidadLista(IdEstado, IdCiudad);
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const localidadesLista: Localidad[] = value;
            setLocalidadLista(localidadesLista);
        }
    }

    const cargarDatos = async (): Promise<void> => {

        setDevice(DeviceConfig.getData());

        if (UsuarioModel.getToken().length > 0) {
            const fechaInicial: string = Fecha.getDateToDay();
            const fechaFinal: string = Fecha.getDateToDay();
            listarReclamos(fechaInicial, fechaFinal);
        } else {
            document.body.innerHTML = "<body></body>";
            Swal.fire({
                icon: "warning",
                title: "Acceso denegado",
                text: `Tienes que iniciar sesión para poder usar el sistema`,
                showConfirmButton: true,
                confirmButtonColor: colors.dorado01,
                confirmButtonText: "Ir al login",
                timerProgressBar: true,
                reverseButtons: true,
                timer: 10000
            }).then(async (response) => {
                if (response.isConfirmed) window.location.href = "/"
            });
            Tiempo.sleep(10).then(() => window.location.href = "/");
        }

    }

    const onChangeReclamoData = (name: string, value: string | number): void => {
        setReclamo((prev: Reclamo) => ({ ...prev, [name]: value }));
    }

    const listarReclamos = async (fechaInicial: string, fechaFinal: string): Promise<void> => {
        const response: Response = await ReclamoService.listar(fechaInicial, fechaFinal);
        const { error } = response;
        if (error === false) {
            const { data: { value } } = response;
            const reclamosLista: Reclamo[] = value;
            setReclamosLista(reclamosLista);
            setLabelUltimaActualizacion(Tiempo.getCurrentTimeFormat12Hour());
        } else {
            toast.error("Error");
        }
    }

    const enviarReclamo = async (): Promise<void> => {
        const { value, arrayErrors } = ReclamoModel.validar(reclamo);
        if (value) {
            setIsOpenModalErrors(true);
            setArrayErrors(arrayErrors);
        } else {
            const response: Response = await ReclamoService.guardar(reclamo);
            if (response.error) {
                toast.error("Error");
            } else {
                listarReclamos(fechaInicial, fechaFinal);
                toast.success("Reclamo guardado");
                setIsOpenModalReclamo(false);
            }
        }
    }

    const eliminarReclamo = async (reclamo: Reclamo): Promise<void> => {

        Swal.fire({
            icon: "question",
            title: "Eliminar reclamo",
            text: `¿Estas seguro de eliminar esta reclamo con folio: ${reclamo.folioAtencion}?`,
            showConfirmButton: true,
            confirmButtonColor: colors.rojo,
            showCancelButton: true,
            cancelButtonText: "No, Eliminar",
            confirmButtonText: "Si, Eliminar",
            timerProgressBar: true,
            reverseButtons: true,
        }).then(async (response) => {
            if (response.isConfirmed) {
                await ReclamoService.eliminar(reclamo.IdReclamacion);
                // await REDECOServices.eliminarQueja(queja.quejasFolio);
                toast.success("Reclamo eliminada");
                listarReclamos(fechaInicial, fechaFinal);
            }
        });
    };

    return (
        <section>
            <ToastContainer limit={3} position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
            <Block height={70} />
            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5 }} >
                <Col style={{ textAlign: "left" }} >
                    <Dashboard style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            window.location.href = "/reune/panel";
                        }}
                    >
                        Ir al Dashboard
                    </Label>
                </Col>
                <Col style={{ textAlign: "right" }} >
                    <Logout style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            Swal.fire({
                                icon: "question",
                                title: "Salir del Sistema",
                                text: `¿Estas seguro de que quieres salir del sistema?`,
                                showConfirmButton: true,
                                confirmButtonColor: colors.dorado01,
                                showCancelButton: true,
                                cancelButtonText: "No",
                                confirmButtonText: "Si",
                                timerProgressBar: true,
                                reverseButtons: true,
                                timer: 10000
                            }).then(async (response) => {
                                if (response.isConfirmed) {
                                    cookies.remove("usuario");
                                    Tiempo.sleep(0.5).then(() => window.location.href = "/");
                                }
                            });
                        }}
                    >
                        Salir del Sistema
                    </Label>
                </Col>
            </Row>

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Col style={{ minWidth: "25%", width: "25%", maxWidth: "25%" }}  >
                    <FormGroup>
                        <Label style={{ color: colors.dorado01 }} >
                            Fecha Inicial
                        </Label>
                        <InputGroup>
                            <Input
                                id="fechaInicial"
                                value={fechaInicial}
                                max={fechaFinal}
                                onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                    setFechaInicial(value);
                                }}
                                style={{ ...ComponentsCSS.Input, marginTop: 0 }}
                                type="date"
                            />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col style={{ minWidth: "25%", width: "25%", maxWidth: "25%" }}  >
                    <FormGroup>
                        <Label style={{ color: colors.dorado01 }} >
                            Fecha Final
                        </Label>
                        <InputGroup>
                            <Input
                                id="fechaFinal"
                                value={fechaFinal}
                                min={fechaInicial}
                                onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                    setFechaFinal(value);
                                }}
                                style={ComponentsCSS.Input}
                                type="date"
                            />
                            <InputGroupText
                                style={ComponentsCSS.InputGroupText}
                                onClick={() => {
                                    listarReclamos(fechaInicial, fechaFinal);
                                }}
                            >
                                <Search style={{ color: colors.dorado01 }} />
                            </InputGroupText>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col style={{ textAlign: "right", minWidth: "50%", width: "50%", maxWidth: "50%" }} >
                    <IconButton style={{ marginTop: 30 }} >
                        <Add
                            style={{ color: colors.dorado01 }}
                            onClick={() => {
                                setReclamo(ReclamoModel.getEstructura());
                                setIsOpenModalReclamo(true)
                            }}
                        />
                    </IconButton>
                    <IconButton
                        style={{ marginTop: 30, marginRight: 5 }}
                        onClick={() => {
                            listarReclamos(fechaInicial, fechaFinal);
                        }}
                    >
                        <Search style={{ color: colors.dorado01 }} />
                    </IconButton>
                </Col>
            </Row>

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5 }} >
                <Label style={{ fontWeight: "bold", fontSize: 18, color: colors.dorado01 }} >
                    Lista de reclamos del {Fecha.formatDateToText(fechaInicial)} al {Fecha.formatDateToText(fechaFinal)}
                </Label>
            </Row>
            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Col>
                    <Label>
                        <i>Ultima actualización a las {labelUltimaActualizacion} <br />
                            Se listaron {reclamosLista.length} consulta(s)</i>
                    </Label>
                </Col>
            </Row>
            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Table
                    columns={columnsReclamos}
                    data={reclamosLista}
                    noDataComponent={<Label style={{ fontWeight: "bold", fontSize: 26, color: colors.gris, marginTop: 50, textAlign: "center" }} >TABLA VACÍA</Label>}
                />
            </Row>

            <Modal
                isOpen={isOpenModalReclamo}
                style={{ maxWidth: device.isDesktop ? "90%" : "100%", fontFamily: '"Fira Sans", sans-serif' }}
            >
                <ModalHeader
                    close={
                        <IconButton
                            onClick={() => setIsOpenModalReclamo(false)}
                            style={{ backgroundColor: colors.blanco01, color: colors.dorado01 }}
                        >
                            <Close />
                        </IconButton>
                    }
                    style={{
                        backgroundColor: colors.dorado01
                    }}
                >
                    <Label style={{ color: colors.blanco01, fontSize: 24 }} >
                        DATOS PARA ENVIAR
                    </Label>
                </ModalHeader>
                <ModalBody style={{ minHeight: "70vh", maxHeight: "70vh", height: "70vh", overflowY: "auto" }} >
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "40%" : "100%", width: device.isDesktop ? "40%" : "100%", maxWidth: device.isDesktop ? "40%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Denominación o razón social
                                </Label>
                                <Input
                                    id="consulta.denominacion"
                                    value={reclamo.denominacion}
                                    style={{ ...ComponentsCSS.Input, cursor: "not-allowed" }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo"}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "30%" : "100%", width: device.isDesktop ? "30%" : "100%", maxWidth: device.isDesktop ? "30%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Sector
                                </Label>
                                <Input
                                    id="consulta.sector"
                                    value={reclamo.sector}
                                    style={{ ...ComponentsCSS.Input, cursor: "not-allowed" }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo"}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "30%" : "100%", width: device.isDesktop ? "30%" : "100%", maxWidth: device.isDesktop ? "30%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Trimestre a informar
                                </Label>
                                <Input
                                    id={"reclamo.trimestre"}
                                    value={reclamo.trimestre}
                                    type="select"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        setReclamo((prev: Reclamo) => ({ ...prev, trimestre: Number(value) }));
                                    }}
                                    disabled={reclamo.IdReclamacion > 0}
                                    style={ComponentsCSS.Input}
                                >
                                    {
                                        listaTrimestre.map((trimestre: Trimestre) => {
                                            return (<option value={trimestre.IdTrimestre}>{trimestre.trimestre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Número de Reclamo
                                </Label>
                                <Input
                                    id={"reclamo.numero"}
                                    value={reclamo.numero}
                                    type="text"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        value = Numero.soloNumero(value);
                                        onChangeReclamoData("numero", Number(value));
                                    }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo, descuerdo a la disposición siempre el valor sera 1"}
                                    style={ComponentsCSS.Input}
                                >
                                    {
                                        listaTrimestre.map((trimestre: Trimestre) => {
                                            return (<option value={trimestre.IdTrimestre}>{trimestre.trimestre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Folio
                                </Label>
                                <Input
                                    id="reclamo.folioAtencion"
                                    value={reclamo.folioAtencion}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("folioAtencion", value);
                                    }}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Estatus
                                </Label>
                                <Input
                                    id={"reclamo.estadoConPend"}
                                    value={reclamo.estadoConPend}
                                    type="select"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("estadoConPend", Number(value));
                                    }}
                                    disabled={reclamo.IdReclamacion > 0}
                                    style={ComponentsCSS.Input}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    <option value={1}>Pendiente</option>
                                    <option value={2}>Concluido</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de reclamación
                                </Label>
                                < Input
                                    id={"reclamo.fechaReclamacion"}
                                    value={reclamo.fechaReclamacion}
                                    type="date"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("fechaReclamacion", value);
                                    }}
                                    disabled={reclamo.IdReclamacion > 0}
                                    style={ComponentsCSS.Input}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de atención
                                </Label>
                                {
                                    Number(reclamo.estadoConPend) === 2 &&
                                    < Input
                                        id={"reclamo.fechaAtencion"}
                                        value={reclamo.fechaAtencion}
                                        type="date"
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("fechaAtencion", value);
                                        }}
                                        disabled={reclamo.IdReclamacion > 0}
                                        style={ComponentsCSS.Input}
                                    />
                                }
                                {Number(reclamo.estadoConPend) === 0 && <><br /> <i>Seleccione un estatus</i></>}
                                {Number(reclamo.estadoConPend) === 1 && <><br /> <i>Esta dato no es necesario si el estatus esta en pendiente</i></>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Medios de recepción o canal
                                </Label>
                                < Input
                                    id={"reclamo.medioRecepcionCanal"}
                                    value={reclamo.medioRecepcionCanal}
                                    type="select"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("medioRecepcionCanal", Number(value));
                                    }}
                                    disabled={reclamo.IdReclamacion > 0}
                                    style={ComponentsCSS.Input}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        mediosAtencionLista.map((value: MedioAtencion) => {
                                            return (<option value={value.IdMedioAtencion}>{value.nombre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Productos
                                </Label>
                                <Input
                                    id="reclamo.productoServicio"
                                    value={reclamo.productoServicio}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("productoServicio", value);
                                        onChangeReclamoData("causaMotivo", "0");
                                        listarCausasProductosLista(value);
                                        // const producto: Producto | undefined = productosLita.find((producto: Producto) => producto.IdProducto === value);                                        
                                        // if (producto) handleConsultaData("productoDescripcion", producto.producto);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        productosLita.map((value: Producto) => {
                                            return (<option value={value.IdProducto}>{value.producto}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "40%" : "100%", width: device.isDesktop ? "40%" : "100%", maxWidth: device.isDesktop ? "40%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Causa
                                </Label>
                                <Input
                                    id="reclamo.causaMotivo"
                                    value={reclamo.causaMotivo}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("causaMotivo", value);
                                        // const causa: Causa | undefined = causasLista.find((causa: Causa) => causa.IdCausa === Number(value));
                                        // if (causa) handleConsultaData("causaDescripcion", causa.causa);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        causasLista.map((value: Causa) => {
                                            return (<option value={value.IdCausa}>{value.causa}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de Resolución
                                </Label>
                                {
                                    Number(reclamo.estadoConPend) === 2 &&
                                    < Input
                                        id={"reclamo.fechaResolucion"}
                                        value={reclamo.fechaResolucion}
                                        type="date"
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("fechaResolucion", value);
                                        }}
                                        disabled={reclamo.IdReclamacion > 0}
                                        style={ComponentsCSS.Input}
                                    />
                                }
                                {Number(reclamo.estadoConPend) === 0 && <><br /> <i>Seleccione un estatus</i></>}
                                {Number(reclamo.estadoConPend) === 1 && <><br /> <i>Esta dato no es necesario si el estatus esta en pendiente</i></>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de Atencion
                                </Label>
                                {
                                    Number(reclamo.estadoConPend) === 2 &&
                                    < Input
                                        id={"reclamo.fechaNotifUsuario"}
                                        value={reclamo.fechaNotifUsuario}
                                        type="date"
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("fechaNotifUsuario", value);
                                        }}
                                        disabled={reclamo.IdReclamacion > 0}
                                        style={ComponentsCSS.Input}
                                    />
                                }
                                {Number(reclamo.estadoConPend) === 0 && <><br /> <i>Seleccione un estatus</i></>}
                                {Number(reclamo.estadoConPend) === 1 && <><br /> <i>Esta dato no es necesario si el estatus esta en pendiente</i></>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Estado
                                </Label>
                                <Input
                                    id="reclamo.entidadFederativa"
                                    value={reclamo.entidadFederativa}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("entidadFederativa", Number(value));
                                        onChangeReclamoData("municipioAlcaldia", 0);
                                        listarCiudades(Number(value));
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        estadosLista.map((value: Estado) => {
                                            return (<option value={value.IdEstado}>{value.nombre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Código Postal
                                </Label>
                                <Input
                                    id="reclamo.codigoPostal"
                                    value={reclamo.codigoPostal}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        if (value.length <= 5) onChangeReclamoData("codigoPostal", Number(Numero.soloNumero(value)));
                                    }}
                                    type={"text"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Ciudad
                                </Label>
                                <Input
                                    id="reclamo.municipioAlcaldia"
                                    value={reclamo.municipioAlcaldia}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("municipioAlcaldia", Number(value));
                                        listarLocalidad(reclamo.entidadFederativa, Number(value));
                                        // const ciudad: Ciudad | undefined = ciudadesLista.find((ciudad: Ciudad) => ciudad.IdCiudad === Number(value));
                                        // if (ciudad) handleConsultaData("municipioDescripcion", ciudad.ciudad);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                >
                                    <option value="0">Seleccione una opción</option>
                                    {
                                        ciudadesLista.map((item: Ciudad) => {
                                            return (
                                                <option value={item.IdCiudad}>{item.ciudad}</option>
                                            )
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Localidad
                                </Label>
                                <Input
                                    id="reclamo.localidad"
                                    value={reclamo.localidad}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("localidad", value);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                >
                                    <option value="0">Seleccione una opción</option>
                                    {
                                        localidadLista.map((item: Localidad) => {
                                            return (
                                                <option value={item.IdLocalidad}>{item.localidad}</option>
                                            )
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Monetario
                                </Label>
                                <Input
                                    id="reclamo.monetario"
                                    value={reclamo.monetario}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("monetario", value);
                                        if (value !== "SI") onChangeReclamoData("montoReclamado", 0);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                >
                                    <option value="null">Seleccione una opción</option>
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Monto Reclamado
                                </Label>
                                {
                                    reclamo.monetario === "SI" &&
                                    <InputGroup>
                                        <InputGroupText style={{ ...ComponentsCSS.Input, backgroundColor: "transparent" }}>
                                            $
                                        </InputGroupText>
                                        <Input
                                            id="reclamo.montoReclamado"
                                            value={reclamo.montoReclamado}
                                            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                onChangeReclamoData("montoReclamado", Number(Numero.soloNumero(value)));
                                            }}
                                            type={"text"}
                                            style={{ ...ComponentsCSS.Input }}
                                            disabled={reclamo.IdReclamacion > 0}
                                        />
                                    </InputGroup>
                                }
                                {reclamo.monetario === "null" && <><br /> <i>Seleccione si es monetario</i></>}
                                {reclamo.monetario === "NO" && <><br /> <i>Esta dato no es necesario si no es monetario</i></>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Importe abonado
                                </Label>
                                {
                                    (reclamo.monetario === "SI" && Number(reclamo.estadoConPend) === 2) &&
                                    <InputGroup>
                                        <InputGroupText style={{ ...ComponentsCSS.Input, backgroundColor: "transparent" }}>
                                            $
                                        </InputGroupText>
                                        <Input
                                            id="reclamo.importeAbonado"
                                            value={reclamo.importeAbonado}
                                            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                onChangeReclamoData("importeAbonado", Number(Numero.soloNumero(value)));
                                            }}
                                            type={"text"}
                                            style={{ ...ComponentsCSS.Input }}
                                            disabled={reclamo.IdReclamacion > 0}
                                        />
                                    </InputGroup>
                                }
                                {reclamo.monetario === "null" && <><br /> <i>Seleccione si es monetario</i></>}
                                {reclamo.monetario === "NO" && <><br /> <i>Esta dato no es necesario si no es monetario</i></>}
                                {(reclamo.monetario === "SI" && Number(reclamo.estadoConPend) !== 2) && <><br /><i>Debe de estar en estatus concluido para poder agregar este valor</i></>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de abono
                                </Label>
                                {
                                    (reclamo.monetario === "SI" && Number(reclamo.estadoConPend) === 2) &&
                                    < Input
                                        id={"reclamo.fechaAbonoImporte"}
                                        value={reclamo.fechaAbonoImporte}
                                        type="date"
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("fechaAbonoImporte", value);
                                        }}
                                        disabled={reclamo.IdReclamacion > 0}
                                        style={ComponentsCSS.Input} f
                                    />
                                }
                                {reclamo.monetario === "null" && <><br /> <i>Seleccione si es monetario</i></>}
                                {reclamo.monetario === "NO" && <><br /> <i>Esta dato no es necesario si no es monetario</i></>}
                                {(reclamo.monetario === "SI" && Number(reclamo.estadoConPend) !== 2) && <><br /><i>Debe de estar en estatus concluido para poder agregar este valor</i></>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    PORI
                                </Label>
                                <Input
                                    id="reclamo.pori"
                                    value={reclamo.pori}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("pori", value);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                >
                                    <option value="null">Seleccione una opción</option>
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Tipo de persona
                                </Label>
                                <Input
                                    id="reclamo.tipoPersona"
                                    value={reclamo.tipoPersona}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        onChangeReclamoData("tipoPersona", Number(value));
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={reclamo.IdReclamacion > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    <option value={1}>Persona Física</option>
                                    <option value={2}>Persona Moral</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Sexo
                                </Label>
                                {
                                    Number(reclamo.tipoPersona) === 1 &&
                                    <Input
                                        id="reclamo.sexo"
                                        value={reclamo.sexo}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("sexo", value);
                                        }}
                                        type={"select"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={reclamo.IdReclamacion > 0}
                                    >
                                        <option value={"null"}>Seleccione una opción</option>
                                        <option value={"H"}>Hombre</option>
                                        <option value={"M"}>Mujer</option>
                                    </Input>
                                }
                                {Number(reclamo.tipoPersona) !== 1 && <><br /> <i>Solo si la persona es física</i> </>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Edad
                                </Label>
                                {
                                    Number(reclamo.tipoPersona) === 1 &&
                                    <Input
                                        id="reclamo.edad"
                                        value={reclamo.edad}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("edad", Number(Numero.soloNumero(value)));
                                        }}
                                        type={"text"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={reclamo.IdReclamacion > 0}
                                    />
                                }
                                {Number(reclamo.tipoPersona) !== 1 && <><br /> <i>Solo si la persona es física</i> </>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Sentido de la resolución
                                </Label>
                                {
                                    Number(reclamo.estadoConPend) === 2 &&
                                    <Input
                                        id="reclamo.sentidoResolucion"
                                        value={reclamo.sentidoResolucion}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("sentidoResolucion", value);
                                        }}
                                        type={"select"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={reclamo.IdReclamacion > 0}
                                    >
                                        <option value={0}>Seleccione una opción</option>
                                        <option value={1}>Total mente favorable para el usuario</option>
                                        <option value={2}>Desfavorable para el usuario</option>
                                        <option value={3}>Parcialmente favorable al usuario</option>
                                    </Input>
                                }
                                {Number(reclamo.estadoConPend) !== 2 && <><br /> <i>Solo si el estatus esta en concluido</i> </>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Nivel de atencion
                                </Label>
                                {
                                    Number(reclamo.estadoConPend) === 2 &&
                                    <Input
                                        id="reclamo.nivelAtencion"
                                        value={reclamo.nivelAtencion}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("nivelAtencion", value);
                                        }}
                                        type={"select"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={reclamo.IdReclamacion > 0}
                                    >
                                        <option value={0}>Seleccione una opción</option>
                                        {
                                            lista.map((item: NA) => {
                                                return (
                                                    <option value={item.index}>{item.label}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                }
                                {Number(reclamo.estadoConPend) !== 2 && <><br /> <i>Solo si el estatus esta en concluido</i> </>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Folio asignado por la CONDUSEF
                                </Label>
                                {
                                    (Number(reclamo.medioRecepcionCanal) === 6 || Number(reclamo.medioRecepcionCanal) === 7) &&
                                    <Input
                                        id="reclamo.folioCondusef"
                                        value={reclamo.folioCondusef}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("folioCondusef", value);
                                        }}
                                        type={"text"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={reclamo.IdReclamacion > 0}
                                    />
                                }
                                {((Number(reclamo.medioRecepcionCanal) !== 6) && (Number(reclamo.medioRecepcionCanal) !== 7)) && <><br /> <i>Valor no requerido</i> </>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Reversa SIGE
                                </Label>
                                {
                                    Number(reclamo.medioRecepcionCanal) === 6 &&
                                    <Input
                                        id="reclamo.reversa"
                                        value={reclamo.reversa}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            onChangeReclamoData("reversa", value);
                                        }}
                                        type={"select"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={reclamo.IdReclamacion > 0}
                                    >
                                        <option value={0}>SI es revers SIEG <i>[Gestión electrónica]</i></option>
                                        <option value={1}>NO es revers SIEG <i>[Gestión electrónica]</i></option>
                                    </Input>
                                }
                                {Number(reclamo.medioRecepcionCanal) !== 6 && <><br /> <i>Valor no requerido</i> </>}
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {
                        reclamo.IdReclamacion === 0 &&
                        <Button
                            style={{ backgroundColor: colors.blanco01, borderColor: colors.dorado01, color: colors.dorado01, fontWeight: "bold", boxShadow: "none" }}
                            onClick={() => {
                                enviarReclamo();
                            }}
                        >
                            Enviar
                        </Button>
                    }
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={isOpenModalErrors}
                style={{ maxWidth: device.isDesktop ? "50%" : "100%", fontFamily: '"Fira Sans", sans-serif' }}
            >
                <ModalHeader
                    close={
                        <IconButton
                            onClick={() => setIsOpenModalErrors(false)}
                            style={{ backgroundColor: colors.blanco01, color: colors.dorado01 }}
                        >
                            <Close />
                        </IconButton>
                    }
                    style={{
                        backgroundColor: colors.dorado01
                    }}
                >
                    <Label style={{ color: colors.blanco01, fontSize: 24 }} >
                        ERRORES DETECTADOS
                    </Label>
                </ModalHeader>
                <ModalBody style={{ minHeight: "70vh", maxHeight: "70vh", height: "70vh", overflowY: "auto" }} >
                    {
                        arrayErrors.map((label: string, index: number) => {
                            return (
                                <>
                                    <Row style={{ marginLeft: 20, marginRight: 0 }} >
                                        <Col>
                                            <Label>
                                                {index + 1}{'.- '}{label}
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            )
                        })
                    }
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ backgroundColor: colors.blanco01, borderColor: colors.dorado01, color: colors.dorado01, fontWeight: "bold", boxShadow: "none" }}
                        onClick={() => setIsOpenModalErrors(false)}
                    >
                        Cerrar
                    </Button>

                </ModalFooter>
            </Modal>
        </section >
    );
}

export default ReclamacionesIndex;